import { StatusHistoryItem } from 'types/contact.type';

// Helper function to calculate duration between two timestamps
export const calculateDuration = (startTime?: string, endTime?: string): string => {
    if (!startTime || !endTime) return '0:00';

    const start = new Date(startTime);
    const end = new Date(endTime);

    const durationMs = end.getTime() - start.getTime();
    if (durationMs <= 0) return '0:00';

    const seconds = Math.floor((durationMs / 1000) % 60);
    const minutes = Math.floor((durationMs / (1000 * 60)) % 60);

    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export interface ProcessedStatusHistory {
    id: string;
    date: Date;
    status: string;
    changedBy: string;
    note: string;
}

// Process history data to only show status changes
export const processStatusHistory = (historyData?: StatusHistoryItem[]): ProcessedStatusHistory[] => {
    if (!historyData?.length) return [];

    const sortedHistory = [...historyData].sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
    });

    const statusChanges: ProcessedStatusHistory[] = [];
    let currentStatus: string | null = null;

    sortedHistory.forEach((item) => {
        const status = item.party_stage;

        if (status !== currentStatus) {
            statusChanges.push({
                id: item.id,
                date: new Date(item.created_at),
                status: status ? status.replace(/_/g, ' ') : 'Unknown',
                changedBy: item.changed_by || 'System',
                note: item.note || '',
            });

            currentStatus = status;
        }
    });

    return statusChanges;
};
